import styled from '../../../config/theme';

const Image = styled.img`
  opacity: 0.6;
  text-align: center;
`;

export default Image;
